// extracted by mini-css-extract-plugin
export default {"radioList":"Health_radioList__c5gob","radioOption":"Health_radioOption__Nt7O3","buttonFooter":"Health_buttonFooter__-f4uA","buttonFooterFixed":"Health_buttonFooterFixed__wtj2L"};